module.exports = __webpack_public_path__ + "img/team-12-modal.7210c91b.jpg";